import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

export default (id: string) => useQuery(['dataset', id], () => peApi.getDataset(id));
